"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useComponent = void 0;
const useBlueBase_1 = require("./useBlueBase");
function useComponent(...keys) {
    const BB = useBlueBase_1.useBlueBase();
    return BB.Components.resolveFromCache(...keys);
}
exports.useComponent = useComponent;
